/* global axios */
import ApiClient from './ApiClient';

class WhatsappManagementAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  base(inboxId) {
    return `${this.url}/${inboxId}/whatsapp_management`;
  }

  groups(inboxId) {
    return axios.get(`${this.base(inboxId)}/groups`);
  }

  group(inboxId, jid) {
    return axios.get(`${this.base(inboxId)}/groups/${encodeURIComponent(jid)}`);
  }

  createGroup(inboxId, data) {
    return axios.post(`${this.base(inboxId)}/groups`, data);
  }

  updateGroup(inboxId, jid, data) {
    return axios.patch(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}`,
      data
    );
  }

  participants(inboxId, jid) {
    return axios.get(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/participants`
    );
  }

  updateParticipants(inboxId, jid, action, participants) {
    return axios.post(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/participants`,
      { operation: action, participants }
    );
  }

  invite(inboxId, jid) {
    return axios.get(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/invite`
    );
  }

  revokeInvite(inboxId, jid) {
    return axios.delete(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/invite`
    );
  }

  sendInvite(inboxId, jid, data) {
    return axios.post(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/invite`,
      data
    );
  }

  setting(inboxId, jid, action) {
    return axios.post(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/settings`,
      { operation: action }
    );
  }

  ephemeral(inboxId, jid, expiration) {
    return axios.post(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/ephemeral`,
      { expiration }
    );
  }

  leave(inboxId, jid) {
    return axios.delete(
      `${this.base(inboxId)}/groups/${encodeURIComponent(jid)}/leave`
    );
  }

  account(inboxId) {
    return axios.get(`${this.base(inboxId)}/account`);
  }

  updateAccount(inboxId, data) {
    return axios.patch(`${this.base(inboxId)}/account`, data);
  }

  removePicture(inboxId) {
    return axios.delete(`${this.base(inboxId)}/account/picture`);
  }

  updatePrivacy(inboxId, data) {
    return axios.patch(`${this.base(inboxId)}/account/privacy`, data);
  }

  audits(inboxId) {
    return axios.get(`${this.base(inboxId)}/audits`);
  }
}

export default new WhatsappManagementAPI();
